import get from 'lodash/get';

// For use with actions and effect controls, but not checks controls.
const nodeMixins = {
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      );
      return errors;
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      );
      return warnings;
    },
    getErrorsById() {
      return (errorId) => this.errors.filter(error => error.metadata.errorId === errorId);
    },
    getErrorsByIdList() {
      return (errorIdList) => this.errors.filter(error => errorIdList.includes(error.metadata.errorId));
    }
  }
};

export default nodeMixins;